Updates the status of a position opening.

This status is provided to help hirers manage position openings.
The SEEK API does not use the position opening's status itself.
